import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app/checkbox-empty",
  "use": "app/checkbox-empty-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app/checkbox-empty\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 2.5H5A2.5 2.5 0 002.5 5v14A2.5 2.5 0 005 21.5h14a2.5 2.5 0 002.5-2.5V5A2.5 2.5 0 0019 2.5zM5 1a4 4 0 00-4 4v14a4 4 0 004 4h14a4 4 0 004-4V5a4 4 0 00-4-4H5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol